import { WindowsFilled } from "@ant-design/icons";
import { useMsal } from "@azure/msal-react";
import { Button } from "antd";
import { setAuthToken } from "auth/authToken";
import { msalScopes } from "auth/msalConfig";
import { Palette } from "config/palette";
import { useBackUrl } from "hooks/useBackUrl";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setError } from "redux/errorSlice";
import { StoreDispatch } from "redux/store";

export const MsEntraLoginPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch<StoreDispatch>();
    const { instance } = useMsal();
    const backUrl = useBackUrl();

    const handleSignIn = useCallback(async () => {
        try {
            const response = await instance.loginPopup({ scopes: msalScopes });
            if (response) {
                setAuthToken(response.accessToken);
                navigate(backUrl());
            }
        } catch {
            dispatch(setError("Microsoft Entra sign in failed"));
        }
    }, [instance, backUrl, dispatch, navigate]);

    return (
        <Button
            type="primary"
            block
            size="large"
            icon={<WindowsFilled />}
            onClick={handleSignIn}
            style={{
                backgroundColor: Palette.HeroGreen,
                borderColor: Palette.HeroGreen,
                color: "#fff",
                fontWeight: "bold",
                height: "45px",
            }}
        >
            Sign In with Microsoft Entra
        </Button>
    );
};
